import type { PhotoFilterInput } from '../types'

export const REPORT_MAX_PHOTOS = 300

/** Order matches the server's REPORT_FIELDS; label keys are literals so the i18n coverage test sees them. */
export const REPORT_FIELDS = [
  { key: 'title', labelKey: 'Photos_report_field_title' },
  { key: 'description', labelKey: 'Photos_report_field_description' },
  { key: 'capturedAt', labelKey: 'Photos_report_field_capturedAt' },
  { key: 'uploadedAt', labelKey: 'Photos_report_field_uploadedAt' },
  { key: 'uploader', labelKey: 'Photos_report_field_uploader' },
  { key: 'location', labelKey: 'Photos_report_field_location' },
  { key: 'trade', labelKey: 'Photos_report_field_trade' },
  { key: 'tags', labelKey: 'Photos_report_field_tags' },
] as const

export const DEFAULT_REPORT_FIELDS: string[] = ['title', 'capturedAt', 'location', 'description']

export type ReportSource = 'selection' | 'filter'

export interface PhotoReportInput {
  photoIds?: string[]
  filter?: PhotoFilterInput
  title: string
  perRow: number
  fields: string[]
  language: 'cs' | 'en'
}

export const reportLanguage = (lng: string | undefined): 'cs' | 'en' => ((lng ?? '').toLowerCase().startsWith('cs') ? 'cs' : 'en')

export function reportInput(o: {
  source: ReportSource
  photoIds: string[]
  filter: PhotoFilterInput
  title: string
  perRow: number
  fields: string[]
  language: 'cs' | 'en'
}): PhotoReportInput {
  const common = { title: o.title.trim(), perRow: o.perRow, fields: o.fields, language: o.language }
  return o.source === 'selection' ? { photoIds: o.photoIds, ...common } : { filter: o.filter, ...common }
}
